import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "例：〒123-4567 〇〇県未来市幸福町1-2", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "例：〇〇ビル1階", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "例：012-345-6789", -1)

import { computed, reactive, ref, unref } from 'vue'
import { ConciergeDepartment } from '@/plugins/nicotto'
import { message } from '@/plugins/message'
import { useValidateForm } from '@/components/ui/validator'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputText from '@/components/ui/InputText.vue'
import InputTel from '@/components/ui/InputTel.vue'
import InputUrl from '@/components/ui/InputUrl.vue'
import InputTextArea from '@/components/ui/InputTextArea.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeDepartment',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', department: ConciergeDepartment): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: ConciergeDepartment
}



// eslint-disable-next-line func-call-spacing


const keys = ['code', 'name', 'locations', 'tel', 'url', 'orderSeq', 'note']
const department = reactive<any>({})
keys.forEach(key => {
  department[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeDepartment]
    },
    set(val) {
      emit('update:modelValue', new ConciergeDepartment({ ...props.modelValue, [key]: val}))
    }
  })
})

const form = ref<HTMLFormElement|null>(null)
const submit = () => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  emit('submit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "form",
    ref: form,
    class: "formTable",
    novalidate: ""
  }, [
    _createVNode(FormGroup, {
      label: "担当課コード",
      required: true,
      "label-for": "department-code"
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          modelValue: department.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((department.code) = $event)),
          label: "担当課コード",
          id: "department-code",
          pattern: "^(?!0)[-_0-9A-Za-z]*$|^0(?=.*[-_A-Za-z])[-_0-9A-Za-z]*$",
          "invalid-pattern-message": _unref(message)('concierge.validation.invalidDepartmentCodePattern'),
          required: ""
        }, null, 8, ["modelValue", "invalid-pattern-message"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "担当課名",
      required: true,
      "label-for": "department-name"
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          label: "担当課名",
          required: true,
          id: "department-name",
          modelValue: department.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((department.name) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "所在地１",
      "label-for": "address1"
    }, {
      default: _withCtx(() => [
        _createVNode(InputTextArea, {
          label: "所在地１",
          id: "address1",
          modelValue: department.locations[0],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((department.locations[0]) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "所在地２",
      "label-for": "address2"
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          label: "所在地２",
          id: "address2",
          modelValue: department.locations[1],
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((department.locations[1]) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "電話番号",
      "label-for": "tel"
    }, {
      default: _withCtx(() => [
        _createVNode(InputTel, {
          modelValue: department.tel,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((department.tel) = $event)),
          id: "tel"
        }, null, 8, ["modelValue"]),
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "URL",
      "label-for": "url"
    }, {
      default: _withCtx(() => [
        _createVNode(InputUrl, {
          id: "url",
          modelValue: department.url,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((department.url) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "結果表示順",
      "label-for": "sort-id"
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          id: "sort-id",
          "model-value": department.orderSeq == null ? null : department.orderSeq.toString(),
          onInput: _cache[6] || (_cache[6] = e => department.orderSeq = e.target?.value),
          pattern: "^[0-9]*$",
          "invalid-pattern-message": _unref(message)('concierge.validation.invalidDepartmentOrderSeqPattern'),
          label: "結果表示順"
        }, null, 8, ["model-value", "invalid-pattern-message"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "備考",
      "label-for": "note"
    }, {
      default: _withCtx(() => [
        _createVNode(InputTextArea, {
          label: "備考",
          modelValue: department.note,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((department.note) = $event)),
          id: "note"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})